import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail, Smartphone } from "lucide-react";
import { DownloadButton } from "@/components/landing/DownloadButtons";

export default function Contact() {
  return (
    <main data-testid="page-contact" className="relative bg-white pb-24 pt-28 lg:pt-36">
      <div className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-72 bg-gradient-to-b from-brand-light/60 to-white" />
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-ink/50 transition-colors hover:text-brand">
          <ArrowLeft className="h-4 w-4" /> Retour à l'accueil
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="mt-8"
        >
          <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-brand-700">
            <span className="h-1.5 w-1.5 rounded-full bg-brand" /> Contact
          </span>
          <h1 className="mt-4 font-display text-4xl font-extrabold tracking-tight text-ink sm:text-5xl">
            Une question&nbsp;? Écris-nous.
          </h1>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-ink/60">
            Pour toute question concernant Leadzi CHR, le dépôt d'opportunités ou un sujet
            administratif, contacte-nous par e-mail. L'ensemble du dépôt et du suivi des
            opportunités se gère directement depuis l'application.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          className="mt-12 grid gap-5 sm:grid-cols-2"
        >
          <a
            href="mailto:contact@leadzi.fr"
            data-testid="contact-email-card"
            className="group rounded-3xl border border-black/5 bg-[#FAFAFA] p-7 transition-all duration-300 hover:-translate-y-1 hover:border-brand/30 hover:shadow-[0_24px_50px_-20px_rgba(232,80,46,0.35)]"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-brand text-white">
              <Mail className="h-6 w-6" />
            </span>
            <h2 className="mt-5 text-lg font-bold text-ink">Par e-mail</h2>
            <p className="mt-1 text-sm text-ink/55">La façon la plus rapide de nous joindre.</p>
            <span className="mt-4 inline-block font-semibold text-brand">contact@leadzi.fr</span>
          </a>

          <div className="rounded-3xl border border-black/5 bg-[#FAFAFA] p-7">
            <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-ink text-white">
              <Smartphone className="h-6 w-6" />
            </span>
            <h2 className="mt-5 text-lg font-bold text-ink">Depuis l'application</h2>
            <p className="mt-1 text-sm text-ink/55">
              Dépose et suis tes opportunités directement dans Leadzi CHR.
            </p>
            <div className="mt-4">
              <DownloadButton testId="contact-download-cta" label="Télécharger l'app" />
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-10 rounded-2xl border border-black/5 bg-white p-6 text-sm text-ink/55"
        >
          <p>
            <strong className="text-ink">Éditeur&nbsp;:</strong> Leadzi CHR — Entreprise individuelle —
            SIRET 791 545 387 00049.
          </p>
        </motion.div>
      </div>
    </main>
  );
}
